import {IonGrid, IonRow, IonCol, IonModal, IonButtons, IonButton, IonIcon, IonContent, IonHeader, IonToolbar, IonTitle, useIonRouter} from "@ionic/react";
import {checkmarkOutline, chevronBack, scan} from "ionicons/icons";
import {QrReader} from "react-qr-reader";
import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;
import {OnResultFunction} from "react-qr-reader/src/types";
import CustomField from "../components/CustomField";
import {useFormInput, validateForm} from "../_/useForms";
import {useEffect, useState} from "react";
import indexBy from "underscore/modules/indexBy";
import styles_Modal_2_1 from './Modal_2_1.module.scss';
import {push_pg_0_24__VenderRedeem} from "../store/Pg_2_Store";
import {handleCommonFetchErrors} from "./Utils";
import {Pg_8_5_Store, push_pg_8_5__scan} from "../store/Pg_8_Store";
import {useStoreState} from "pullstate";
import {getPageData} from "../store/Selectors";


export const useLoginFields = (Item_會員) => {
    return [
        {
            id: "create_nickname",
            label: "暱稱",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "暱稱",
                    autocomplete: "false"
                },
                state: useFormInput("")
            }
        },
        {
            id: "create_email",
            label: "Email",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "Email",
                    autocomplete: "false"
                },
                state: useFormInput("")
            }
        },
        // {
        //     id: "手機國碼",
        //     label: "手機國際碼",
        //     required: true,
        //     input: {
        //         props: {
        //             type: "text",
        //             placeholder: "手機國際碼",
        //         },
        //         state: useFormInput(Item_會員.手機國碼, (val, oldVal) => {
        //
        //         })
        //     }
        // },
        // {
        //     id: "手機號碼",
        //     label: "手機號碼",
        //     required: true,
        //     input: {
        //         props: {
        //             type: "text",
        //             placeholder: "手機號碼",
        //             autocomplete: "tel-local"
        //         },
        //         state: useFormInput(Item_會員.手機, (val, oldVal) => {
        //
        //         })
        //     }
        // },
        {
            id: "create_phone",
            label: "手機號",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "手機號 (台灣手機免打國際碼，開頭為0)",
                    autocomplete: "false"
                },
                state: useFormInput("")
            }
        },
        {
            id: "create_password",
            label: "密碼",
            required: false,
            input: {
                props: {
                    type: "text",
                    placeholder: "密碼 (預設 設成 '手機號' 則免填留空)",
                },
                state: useFormInput("")
            }
        },
    ];
}

export const Modal_8_5_Scan = ({Item_會員, dismiss, onResult}) => {
    const router = useIonRouter();
    let [mode, setMode] = useState(1);
    const pgData = useStoreState(Pg_8_5_Store, getPageData);

    //#region Back button
    useEffect(() => {
        let callback: any = (ev) => {
            // ev.detail.register(10, () => {
            //     console.log('Handler was called!');
            // });

            dismiss();
        };

        document.addEventListener('ionBackButton', callback);
        // Remove listener on unmount
        return () => document.removeEventListener("ionBackButton", callback);
    }, []);
    //#endregion


    const fields = useLoginFields(Item_會員);
    let keyedFields = indexBy(fields, 'id');


    const [errors, setErrors] = useState(false);

    const handleScan = result => {
        if (result) {
            //setQRData(result);
            //play();
            //handleSuccess(result);
            alert(`代碼: ${result.text}`);
            keyedFields.code.input.state.reset(result.text);
            //onResult(result);
        }
    }

    const _push_redeem = async () => {
        const errors = validateForm(fields);
        setErrors(errors);

        if (!errors.length) {
            const create_nickname = fields && (keyedFields.create_nickname as any).input.state.value;
            const create_email = fields && (keyedFields.create_email as any).input.state.value;
            const create_phone = fields && (keyedFields.create_phone as any).input.state.value;
            const create_password = fields && (keyedFields.create_password as any).input.state.value;

            //const 手機國碼 = fields && (keyedFields.手機國碼 as any).input.state.value;
            //const 手機號碼 = fields && (keyedFields.手機號碼 as any).input.state.value;


            let error: any = null;
            if (error = (await push_pg_8_5__scan({
                create_nickname: create_nickname,
                create_email: create_email,
                create_phone: create_phone,
                create_password: create_password,
            }))) {
                if (!handleCommonFetchErrors(router, error)) { //沒有成功被處理
                    dismiss();

                    if (onResult) {
                        onResult(true);
                    }
                }
            }

        } else {
        }
    }


    return <>
        <IonHeader>
            <IonToolbar>
                <IonTitle>直接建立帳號</IonTitle>
                <IonButtons slot="start">
                    <IonButton onClick={dismiss}>
                        <IonIcon size="large" icon={chevronBack} style={{marginLeft: "-0.7rem"}}/>
                    </IonButton>
                </IonButtons>
            </IonToolbar>
        </IonHeader>

        <IonContent fullscreen>
            <IonGrid>
                {/*<IonRow className="ion-text-center ion-margin-top" >*/}
                {/*    <IonCol size="12">*/}
                {/*        <IonIcon style={{ fontSize: "5rem" }} icon={ props.modalOptions.icon } />*/}
                {/*    </IonCol>*/}
                {/*</IonRow>*/}
                {mode === 2 &&
                    <IonRow className="ion-justify-content-center ion-text-center">
                        <IonCol>
                            <IonButton fill={"solid"} onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                setMode(1);

                                return false;
                            }}>
                                關閉掃描
                            </IonButton>
                        </IonCol>
                    </IonRow>
                }

                {mode === 2 &&
                    <div className={styles_Modal_2_1.readerContainer}>
                        <div className={styles_Modal_2_1.reader}>
                            <QrReader
                                containerStyle={{maxHeight: '350px'}}
                                constraints={{facingMode: 'environment'}}
                                scanDelay={500}
                                videoId={'video'}
                                onResult={handleScan}
                                videoStyle={{height: "350px"}}
                            />
                        </div>
                        <div className={styles_Modal_2_1.readerBg}>
                            <div className={styles_Modal_2_1.readerBgText}>若方框內為空白畫面，表示沒有權限操作相機，請手動輸入兌換碼</div>
                        </div>
                    </div>
                }

                <IonRow className="ion-justify-content-center">
                    <IonCol>

                    </IonCol>
                </IonRow>

                {/*<IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">*/}
                {/*    <IonCol>*/}
                {/*        <IonButton fill={"solid"}>*/}
                {/*            兌換*/}
                {/*        </IonButton>*/}
                {/*    </IonCol>*/}
                {/*</IonRow>*/}

                <IonRow>
                    <IonCol>
                        {fields.map((f: any) => {
                            return <CustomField className={styles_Modal_2_1.marginTop} key={f.id} field={f} errors={errors} noLabelSlot={false}/>
                        })}
                    </IonCol>
                </IonRow>

                <IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">
                    <IonCol>
                        <IonButton fill={"solid"} onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            _push_redeem();

                            return false;
                        }}>
                            確定建立
                        </IonButton>
                    </IonCol>
                </IonRow>

                {/*{mode === 1 &&*/}
                {/*    <IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">*/}
                {/*        <IonCol>*/}
                {/*            <IonButton fill={"solid"} onClick={(e) => {*/}
                {/*                e.preventDefault();*/}
                {/*                e.stopPropagation();*/}

                {/*                setMode(2);*/}

                {/*                return false;*/}
                {/*            }}>*/}
                {/*                打開掃描*/}
                {/*            </IonButton>*/}
                {/*        </IonCol>*/}
                {/*    </IonRow>*/}
                {/*}*/}
            </IonGrid>
        </IonContent>
    </>;
};
